import React from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';

import RootOnwrApp from './RootOnwrApp';
import RootOnwrMap from './RootOnwrMap';

export default function App() {
  const location = useLocation();

  if (location.pathname === '/'
  || location.pathname === '/one_map'
  || location.pathname === '/one_map/'
  || location.pathname === '/one_map/main'
  || location.pathname === '/main'
  || location.pathname === '') {
    return (<RootOnwrMap />);
  }

  return (<RootOnwrApp />);
}
